import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getService = id => {
  return http.get(
    `${getBaseUrl()}/service/${id}`
  );
};

export const getPersonServices = (paginate) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/person_service`
    );
  }
  return http.get(
    `${getBaseUrl()}/person_service?${paginate}`
  );
};

export const getAgentServices = (paginate) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/agent_service`
    );
  }
  return http.get(
    `${getBaseUrl()}/agent_service?${paginate}`
  );
};

export const updateService = data => {

  return http.put(
    `${getBaseUrl()}/service/${data.id}`,
    data
  );
};

export const updateServicePrice = data => {

  return http.put(
    `${getBaseUrl()}/service_price/${data.id}`,
    data
  );
};

export const updateServiceStatus = data => {

  return http.put(
    `${getBaseUrl()}/service_status/${data.id}`,
    data
  );
};

export const updateServiceSupport = data => {
  return http.put(
    `${getBaseUrl()}/service_support/${data.id}`,
    data
  );
};

export const updateServiceFinish = serviceId => {

  return http.put(
    `${getBaseUrl()}/service_finish/${serviceId}`
  );
};

export const updateServicePayment = data => {

  return http.put(
    `${getBaseUrl()}/service_payment/${data.id}`,
    data
  );
};

export const updateServiceFirstPayment = data => {

  return http.put(
    `${getBaseUrl()}/service_first_payment/${data.id}`,
    data
  );
};

export const updateServiceSecondPayment = data => {

  return http.put(
    `${getBaseUrl()}/service_second_payment/${data.id}`,
    data
  );
};

export const submitService = data => {

  return http.post(
    `${getBaseUrl()}/person_service`,
    data
  );
};

export const getAgentServiceDocumentation = (service_id) => {

  return http.get(
    `${getBaseUrl()}/agent_service_documentation/${service_id}`,
  );
};

export const submitAgentServiceDocumentation = data => {

  return http.post(
    `${getBaseUrl()}/agent_service_documentation`,
    data
  );
};

export const updateAgentServiceDocumentation = data => {
  return http.put(
    `${getBaseUrl()}/agent_service_documentation/${data.id}`,
    data
  );
};

export const updatePersonServiceDocumentation = data => {
  http.hasFile();
  return http.put(
    `${getBaseUrl()}/person_service_documentation`,
    data
  );
};

export const submitAdminSupportServiceDocumentation = data => {
  http.hasFile();
  return http.post(
    `${getBaseUrl()}/admin_support_service_documentation`,
    data
  );
};

export const updateAdminSupportServiceDocumentation = data => {
  http.hasFile();
  return http.put(
    `${getBaseUrl()}/admin_support_service_documentation/${data.id}`,
    data
  );
};
